// Badge sur l'icône de l'app (compteur de notifications non lues).
// Plugin @capawesome/capacitor-badge (ShortcutBadger). COSMÉTIQUE : selon le
// launcher Android (Pixel/stock n'affichent souvent qu'un point), le nombre
// peut ne pas s'afficher → jamais une source de vérité métier. No-op sur web.
import { isNativeSync } from "./pushNative";

export async function setAppBadge(count) {
  if (!isNativeSync()) return;
  try {
    const { Badge } = await import("@capawesome/capacitor-badge");
    const sup = await Badge.isSupported();
    if (!sup?.isSupported) return;
    const n = Number(count) || 0;
    if (n > 0) await Badge.set({ count: n });
    else await Badge.clear();
  } catch (e) { /* plugin absent / non supporté */ }
}
